import styled from "styled-components";
import { buildColor, breakpoints } from "@tvg/design-system";
import { MtpWarningProps } from "./types";

export const WarningContainer = styled.div<
  Pick<MtpWarningProps, "isBetSlipExpanded">
>`
  padding-right: 12px;
  padding-left: 12px;
  transition: padding-left 0.2s linear;
  @media screen and ${breakpoints.desktop.min.xl} {
    padding-left: ${({ isBetSlipExpanded }) =>
      isBetSlipExpanded ? "90px" : "calc(var(--lhn-width, 292px) + 28px)"};
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

export const WarningWrapper = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${buildColor("red", "000")};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid ${buildColor("red", "100")};
`;
